exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-title[data-v-52b3ce86] {\n  margin-bottom: 1rem;\n}", ""]);

// exports
